var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-ax",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M106.3 0h1133.3v850H106.3z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(.56472 0 0 .56482 -60 -.1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0053a5",
    d: "M0 0h1300v850H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffce00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400 0h250v850H400z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 300h1300v250H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#d21034"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475 0h100v850H475z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 375h1300v100H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAx);
export default __webpack_public_path__ + "static/media/ax.4ca93cfb.svg";
export { ForwardRef as ReactComponent };